import useFetcher from "@/utils/use-fetcher";
import useYWR, { YWRKey } from "@/features/ui/hooks/use-ywr";
import { calcUrl } from "@/features/ui/helpers/fetcher-helpers";
import { CompanyType } from "@/features/types";
import { PriceAdjustedBy } from "@/features/line-sheet-sets/line-sheet-set.types";

export interface UpdateLineSheetTabRequest {
  products: {
    id: number;
    priceAdjustedBy: PriceAdjustedBy;
  }[];
}

export interface UpdateLineSheetTabResponse {}

export interface UpdateLineSheetTabPathParameter {
  by: CompanyType;
  companyId: number;
  lineSheetSetId: number;
  lineSheetId: number;
  lineSheetTabIndex: number;
}

export const updateLineSheetTabTemplateUrl = `/:by/:companyId/line-sheet-sets/:lineSheetSetId/line-sheets/:lineSheetId/line-sheet-tabs/:lineSheetTabIndex`;

export const updateLineSheetTabKey: YWRKey<UpdateLineSheetTabPathParameter> = {
  url: (parameter) => {
    return calcUrl(updateLineSheetTabTemplateUrl, parameter);
  },
  method: "patch",
};

export default function useUpdateLineSheetTab() {
  const fetcher = useFetcher<
    UpdateLineSheetTabRequest,
    UpdateLineSheetTabResponse
  >();

  return useYWR(updateLineSheetTabKey, fetcher);
}
